import MuiBox from '@mui/material/Box'

type TextProps = {
  children: string
}

export default function TextBox({ children }: TextProps) {
  return <MuiBox sx={{ whiteSpace: 'pre-wrap', wordBreak: 'keep-all', overflowWrap: 'anywhere' }}>{children}</MuiBox>
}
